import React from 'react';
import { Title } from './styled';

const Header = ({text}: {text: string}) => {
  return <Title>{text}</Title>;
};
export default Header;
